<template>
  <modal :show.sync="modalEdit">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.measurements.edit.title") }}
    </h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(editUnidadMedida)">
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? 'La longitud mínima para el nombre es de 2 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.measurements.headers.name')"
                v-model="item.nombre"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? 'La longitud mínima para el nombre es de 5 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.measurements.headers.abbreviation')"
                v-model="item.abreviacion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-sm-6 form-group has-label">
          <div class="row">
            <label style="margin-left: 15px">{{
              $t("app.general.state")
            }}</label>
          </div>
          <template>
            <n-switch v-model="item.activo">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
export default {
  components: {},
  data() {
    return {
      item: {
        idUnidadMedida: 0,
        nombre: "",
        abreviacion: "",
        activo: true,
        idEmpresa: 1
      },
      payload: {
        idUnidadMedida: 0,
        nombre: "",
        abreviacion: "",
        activo: true,
        idEmpresa: 1
      },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modalEdit: false
    };
  },
  mounted() {
    EventBus.$on("unidad-medida-edit", async item => {
      //console.log(item);
      this.item = item;
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modalEdit = true;
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async editUnidadMedida() {
      this.payload.idUnidadMedida = this.item.idUnidadMedida;
      this.payload.nombre = this.item.nombre;
      this.payload.abreviacion = this.item.abreviacion;
      this.payload.activo = this.item.activo;
      this.payload.idEmpresa = 0;
      console.log(this.payload);
      await this.$http
        .put(route("UnidadMedida/UpdateUnidadMedida"), this.payload)
        .then(
          async response => {
            //console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelEdit();
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
